import { Injectable } from "@angular/core";
import { BackendService } from "./common/backend.service";
import { HttpErrorHandlerService } from "./common/http-error-handler.service";

export interface SendPushNotificationRequest {
  studentEmail?: string;
  studentUuid?: string;
  title: string;
  body: string;
}

export interface SendPushNotificationResponse {
  atLeastOneSuccessful: boolean;
  studentUuid: string;
}

@Injectable({
  providedIn: "root",
})
export class StudentNotificationService {
  private readonly apiUrlFragment = "/api/admin/notify_student/send_push_noti_to_student";

  constructor(
    private backendService: BackendService,
    private httpErrorHandlerService: HttpErrorHandlerService
  ) {}

  /**
   * Sends a push notification to a student identified by email or UUID.
   *
   * @param request The notification request containing student identifier and message
   * @returns The response indicating success and the student UUID
   */
  public async sendPushNotification(
    request: SendPushNotificationRequest
  ): Promise<SendPushNotificationResponse> {
    try {
      const response: SendPushNotificationResponse = await this.backendService.callApi(
        this.apiUrlFragment,
        "POST",
        request
      );
      return response;
    } catch (error: any) {
      this.httpErrorHandlerService.handleError(
        error,
        "Hiba az értesítés küldése közben."
      );
      throw error;
    }
  }
}
